import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import SEO from './SEO';
import IconTimer from '../atoms/IconTimer';
import PreHead from './PreHead';

const Holder = styled.header`

`;

const PostHead = styled.div`
  display: flex;
  align-items: center;
  svg {
    height: 2rem;
    width: auto;
  }
  p {
    line-height: 1;
    margin: 0 0 0 1rem;
  }
`;

class Header extends Component {
  render() {
    const { pageTitle, mins } = this.props;
    return (
      <Holder>
        <PreHead/>
        <SEO title={pageTitle}/>
        <h1>{pageTitle}</h1>
        <PostHead>
          <IconTimer/>
          <p className="h5">{mins} mins</p>
        </PostHead>
      </Holder>
    )
  }
}

Header.propTypes = {
  pageTitle: PropTypes.string,
  mins: PropTypes.number
};

Header.defaultProps = {
  pageTitle: 'TTC Discovery Exercises'
};

export default Header;
